
import { css } from 'lit';
export default css`
/* Apply standardized box sizing to the component. */
:host {
  box-sizing: border-box;
  font-family: var(--ff-display);
}
:host *,
:host *::before,
:host *::after {
  box-sizing: inherit;
}
/* unset browser defaults for headings and p */
:host:is(h1,h2,h3,h4,h5,h6,p),
h1,h2,h3,h4,h5,h6 {
  all: unset;
}
/* Image reset */
img {
  max-width: 100%;
}
/* Apply proper CSS for accessibly hiding elements to each component. */
.sr-only,
.visually-hidden {
  position: absolute !important;
  overflow: hidden;
  clip: rect(1px, 1px, 1px, 1px);
  width: 1px;
  height: 1px;
  word-wrap: normal;
}
/* Apply component specific CSS */
:host{
  color:var(--sic-heading-color);
  font-family:var(--ff-display);
  font-weight:var(--fw-bold);
  display:block;
}

h1,
h2,
h3,
h4,
h5,
h6{
  margin:0;
}

:host([level-size]),
:host([level-size]) h1,
:host([level-size]) h2,
:host([level-size]) h3,
:host([level-size]) h4,
:host([level-size]) h5,
:host([level-size]) h6{
  font-size:var(--heading-font-size);
  line-height:var(--heading-line-height);
}

h1,
.headline-07{
  font-size:var(--headline-07-font-size);
  line-height:var(--headline-07-line-height);
}

h2,
.headline-06{
  font-size:var(--headline-06-font-size);
  line-height:var(--headline-06-line-height);
}

h3,
.headline-05{
  font-size:var(--headline-05-font-size);
  line-height:var(--headline-05-line-height);
}

h4,
.headline-04{
  font-size:var(--headline-04-font-size);
  line-height:var(--headline-04-line-height);
}

h5,
.headline-03{
  font-size:var(--headline-03-font-size);
  line-height:var(--headline-03-line-height);
}

h6,
.headline-02{
  font-size:var(--headline-02-font-size);
  line-height:var(--headline-02-line-height);
}

.headline-01{
  font-size:var(--headline-01-font-size);
  line-height:var(--headline-01-line-height);
}

:host([level-style='normal']){
  font-weight:var(--fw-normal);
}
`;